var map = null, zip = false, geocoder = null, markers = {}, countyLayer = null, stateLayer = null, federalLayer = null, doctorTimeoutes = {}, doctorMarkers = [], allMarkers = [], newLocal = {};
function generateLocalMap(){
	if(compareNDX != undefined){
		geocoder = new google.maps.Geocoder();
		var setMarkers = true;
		var nursingHomesDimension = mainDimension;
		if(mainGraphFilter != 'compare-star'){
			var filter = 'overall_rating';
			compareStarRatings.forEach(function(d){
			    if(d.selected){
			        filter = d.key;
			    }
			});
			nursingHomesDimension = compareNDX.dimension(function(d){
			    return d[filter];
			});
		}
		var facilities = nursingHomesDimension.top(Infinity);
		if(zip !== false){
			var codeAddressCallback = function(address, type){
					if(!(zip in newLocal)){
						codeAddress(address, function(results){
							if(!(zip in newLocal)){
								var readable = {};
								var addressParts = results[0].address_components;
								addressParts.forEach(function(d){
									if(d.types.indexOf('locality') > -1){
										readable['city'] = d.long_name;
									}else if(d.types.indexOf('administrative_area_level_2') > -1){
										readable['county'] = d.long_name.replace(/(county)/i, '').trim();
									}else if(d.types.indexOf('administrative_area_level_1') > -1){
										readable['state'] = d.short_name;
									}else if(d.types.indexOf('country') > -1){
										readable['country'] = d.short_name;
									}
								});
								if(!('county' in readable) && type != 'zip'){
									readable['county'] = readable['city']; //typically
								}else if(type == 'zip' && !('county' in readable)){
									codeAddressCallback(readable['city']+' '+readable['state'], 'city');
								}
								if('county' in readable){
									newLocal[zip] = {geo: results[0].geometry.location, readable: readable, isInZip: true};
									generateLocalMap();
								}
							}
						});
				}else{
					var localGeo = newLocal[zip].geo;
				}
			}
			codeAddressCallback(zip, 'zip');
		}else{
			var localGeo = {lat: parseFloat(thisFacilityData.latitude), lng: parseFloat(thisFacilityData.longitude)};
		}
		
		for(var mark in markers){
			markers[mark].setMap(null);
			delete markers[mark];
		}

		if(map == null){
			map = new google.maps.Map(document.getElementById('localMap'), {
				center: localGeo,
				zoom: 12,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				mapTypeControl: false,
				streetViewControl: false,
				zoomControl: true,
				zoomControlOptions: {
			        position: google.maps.ControlPosition.TOP_RIGHT
			    }
			});
		}
		$('.mapBlue').parent().show();
		$('#mapKeyLeft').hide();
		map.setOptions({styles: []});
		if(countyLayer != null) countyLayer.setMap(null);
		if(stateLayer != null) stateLayer.setMap(null);
		if(federalLayer != null) federalLayer.setMap(null);

		if(zip !== false && !(zip in newLocal)){
			return;
		}else if(zip !== false){
			localGeo = newLocal[zip].geo;
		}


		if(nearbyRange == 'city' || nearbyRange == 'zip'){
			map.setCenter(localGeo);
			map.setZoom(12);
		}

		if(countyLayer == null){
			countyLayer = new google.maps.FusionTablesLayer({
				suppressInfoWindows: true,
				query:{
					select: 'geometry',
					from: '1xdysxZ94uUFIit9eXmnw1fYc6VcQiXhceFd_CVKa',
					where: "'State Abbr.' = '"+(zip == false ? thisFacilityData.state : newLocal[zip].readable.state)+"'"
				},
				styles: [{
					polygonOptions: {
			        fillColor: '#ffffff',
			        fillOpacity: 0.1,
			        strokeColor: '#3a86b1',
			        strokeWeight: "2"
			      }
				},{
			      	where: "'County Name' = '"+(zip == false ? thisFacilityData.state : newLocal[zip].readable.county)+"'",
			      	polygonOptions: {
			      		fillColor: '#ffffff',
			      		strokeColor: '#E2A82D',
			      		fillOpacity: 0.01,
			      	}
			      }]
			});
		}
		if(nearbyRange == 'county'){
			countyLayer.setMap(map);
			map.setCenter(localGeo);
			map.setZoom(9);
		}

		if(stateLayer == null){
			stateLayer = new google.maps.FusionTablesLayer({
				suppressInfoWindows: true,
				query:{
					select: "'geometry', 'County Name'",
					from: '1xdysxZ94uUFIit9eXmnw1fYc6VcQiXhceFd_CVKa',
					where: "'State Abbr.' = '"+thisFacilityData.state+"'"
				},
				styles: [{
					polygonOptions: {
			        fillColor: '#ffffff',
			        fillOpacity: 0.1,
			        strokeColor: '#3a86b1',
			        strokeWeight: "2"
			      }
				}]
			});
		}
		if(nearbyRange == 'state'){
			setMarkers = false;
			stateLayer.setMap(map);
			map.setCenter({lat: parseFloat(thisFacilityData.latitude), lng: parseFloat(thisFacilityData.longitude)});
			map.setZoom(5);
			if(nearbyRange == 'state'){
				if(facilities.length != 0 && ('providers' in facilities[0])){
					var mapStyles = [
						{
							featureType: 'administrative.province',
							elementType: 'labels',
							stylers: [
								{visibility: 'off'}
							]
						}
					];
					map.setOptions({styles: mapStyles});
					setLayerColors(stateLayer, 'County Name', 'county', thisFacilityData.county);
				}
			}
			$('.mapBlue').parent().hide();
			$('#mapKeyLeft').show();
		}

		
		if(federalLayer == null){
			federalLayer = new google.maps.FusionTablesLayer({
				suppressInfoWindows: true,
				query:{
					select: 'geometry',
					from: '17aT9Ud-YnGiXdXEJUyycH2ocUqreOeKGbzCkUw',
				},
				styles: [{
					polygonOptions: {
			        fillColor: '#ffffff',
			        fillOpacity: 0.1,
			        strokeColor: '#3a86b1',
			        strokeWeight: "2"
			      }
				}]
			});
		}
		if(nearbyRange == 'federal'){
			setMarkers = false;
			federalLayer.setMap(map);
			newCenter = new google.maps.LatLng(42.879094, -97.381205);
			map.panTo(newCenter);
			map.setZoom(4);
			if(nearbyRange == 'federal'){
				if(facilities.length != 0 && ('state' in facilities[0])){
					setLayerColors(federalLayer, 'id', 'state');
				}
			}
			$('.mapBlue').parent().hide();
			$('#mapKeyLeft').show();
		}

		var chartData = (mainChart.allGroups == undefined ? mainChart.group().all() : getAllGroupData(mainChart)).filter(function(d){
			if(d.value.total != undefined && d.value.total != 0){
				return true;
			}
			return false;
		});

		var hoverMarkerFunc = function hoverMarker(marker, img){
			marker.setIcon(img);
		}

		var hoverOutMarkerFunc = function hoverOutMarker(marker, img){
			marker.setIcon(img);
		}

		if(!zip){
			//marker for this facility
			var thisMarker = new google.maps.Marker({
				position: localGeo,
				map: map,
				title: thisFacilityData.facility_name,
				icon: '/assets/images/map/thisNursing.png'
			});
			markers[thisFacilityData.federal_provider_number] = thisMarker;
		}
		doctorMarkers.forEach(function(d){
			d.setMap(null);
		});
		allMarkers = [];
		if(setMarkers){
			facilities.forEach(function(d){
				if(d.facility_name !== thisFacilityData.facility_name){
					var newMarker = new google.maps.Marker({
						position: {lat: parseFloat(d.latitude), lng: parseFloat(d.longitude)},
						map: map,
						title: d.facility_name,
						icon: '/assets/images/map/otherNursing.png'
					});
					newMarker.providerNumber = d.federal_provider_number;
					newMarker.selected = true;
					newMarker.addListener('mouseover', function(){hoverMarkerFunc(newMarker, '/assets/images/map/otherNursingHover.png');});
					newMarker.addListener('mouseout', function(){hoverOutMarkerFunc(newMarker, '/assets/images/map/otherNursing.png');});

					markers[d.federal_provider_number] = newMarker; 
					allMarkers.push(newMarker);
				}
			});

			doctorMarkers = [];
			/*
			var passData = {
				range: nearbyRange
			};
			$.getJSON('/_includes/analytics.php?action=getPhysicians', passData, function(data){
				physiciansLocations = data;
				for(var i = 0; i < physiciansLocations.length; i++){
					if(physiciansLocations[i].latitude == undefined || physiciansLocations[i].longitude == undefined){
						physiciansLocations.splice(i,1);
						if(i != 0){
							i--;
						}
					}
				}
				physiciansLocations.forEach(function(d){
					var newMarker = new google.maps.Marker({
						position: {lat: parseFloat(d.latitude), lng: parseFloat(d.longitude)},
						map: map,
						title: d.frst_nm+' '+d.lst_nm,
						icon: '/images/map/doctor.png'
					});
					newMarker.addListener('mouseover', function(){hoverMarkerFunc(newMarker, '/images/map/doctorHover.png');});
					newMarker.addListener('mouseout', function(){hoverOutMarkerFunc(newMarker, '/images/map/doctor.png');});
					doctorMarkers.push(newMarker);
				})			
			});	
*/
		}
}
function setLayerColors(layer, id, graphDataName, ignore){
	layer.styles = [];
	var filter, polygonCallback;
	if(mainGraphFilter == 'compare-star'){
		filter = 'overall_rating';
		compareStarRatings.forEach(function(d){
		    if(d.selected){
		        filter = d.key;
		    }
		});
		var data = [];
		var facilitiesMap = {};
		facilities.forEach(function(d){
			if(!(Math.round(d[filter]) in facilitiesMap)){
				facilitiesMap[Math.round(d[filter])] = [];
			}
			facilitiesMap[Math.round(d[filter])].push(d);
		});
		for(var rating in facilitiesMap){
			data.push(facilitiesMap[rating].map(function(facility){
				return facility[graphDataName];
			}));
		}
		polygonCallback = function(i){
			var fill, stroke;
			switch(i){
				case 0:
					fill = '#ff413c';
					stroke = '#ff413c';
					break;
				case 1:
					fill = '#ff9f9e';
					stroke = '#ff9f9e';
					break;
				case 3:
					fill = '#7beb9e';
					stroke = '#7beb9e';
					break;
				case 4:
					fill = '#4aad69';
					stroke = '#4aad69';
					break;
				default:
					break;
			}
			return {
		      		fillColor: fill,
		      		strokeColor: stroke,
		      		fillOpacity: 0.1,
		      	};
		}

	}
	layer.styles.push({ //this is our 2 google only allows us to have 5 styles
				polygonOptions: {
		        fillColor: '#fcd984',
		        fillOpacity: 0.1,
		        strokeColor: '#fcd984',
		      }});
	data.forEach(function(d, i){
		if(i == 2) return;
		var where = "'"+id+"' IN (",
		 	style = {
				polygonOptions: polygonCallback(i)
			};
		d.forEach(function(c){
			if(ignore != undefined){
				if(c == ignore) return;
			}
			where += "'"+c+"', ";
		});
		where = where.substr(0, where.length - 2) + ")";
		style['where'] = where;
		layer.styles.push(style);
	});
	layer.setOptions({suppressInfoWindows: false});

	layer.setMap(map);
}

}
$('#searchMapInput').keypress(function(event){
	var keyCode = (event.keyCode ? event.keyCode : event.which);
	if (keyCode > 31 && (keyCode < 48 || keyCode > 57) && keyCode != 45){
		return false;
	}
	if(keyCode == '13'){
		$('#searchMapGo').click();
	}
});
$('#searchMapGo').click(function(e){
	e.preventDefault();
	if($('#searchMapInput').val() == ''){
		zip = false;
		if(nearbyRange == 'zip'){
			nearbyRange = 'city';
		}
		getCompareData(true);
		return false;
	};
	codeAddress($('#searchMapInput').val(), function(results){
		var addressParts = results[0].address_components;
		var country = false;
		addressParts.forEach(function(d){
			if(d.types.indexOf('country') > -1){
				country = d.short_name;
			}
		});
		if(!country || country != 'US'){
			return false;
		}
		var callback = function(){
			nearbyRange = 'zip';
			zip = $('#searchMapInput').val();
			generateGraphs(true);
		}
		nearbyRange = 'zip';
		getCompareData(true, callback, $('#searchMapInput').val());
		return false;
	});
	return false;
});

function codeAddress(zipCode, callback){
	var results;
    geocoder.geocode({'address': zipCode}, function(results, status){
      if(status == google.maps.GeocoderStatus.OK){
        callback(results);
        $('#searchMapInput').css('background', 'inherit');
      }else{
        $('#searchMapInput').css('background', '#ffc9c8');
      }
    });
}
